import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import isNil from 'utils/isNil';
import Text from 'components/Text';

/**
 * Using Gatsby-image to output images.
 * If src returns undefined || null || '' return null
 * If src is a gatsby-image render Img
 * If src is statically
 * Gatsby-image does not do error handling.
 * @param src - fluid object returned by graphQL query
 * @param alt - contentful image asset 'title' field
 */
// @TODO: Properly add alt text

export const WebsiteImage = ({
  src,
  alt = 'Product Illustration',
  marginTop,
  marginBottom,
  imageStyles,
  width,
  maxWidth,
  ...otherProps
}) => {
  if (!isNil(src) && src !== '') {
    const style = {
      marginTop: marginTop,
      marginBottom: marginBottom,
      width: width,
      maxWidth: maxWidth,
      ...imageStyles,
    };

    if (src?.fluid?.src) {
      //gatsby-image fluid object
      return <Img fluid={src.fluid} alt={alt} imgStyle={style} {...otherProps} />;
    } else {
      const src_string = src?.file?.url || src;
      return <img src={src_string} alt={alt} style={style} {...otherProps} />;
    }
  } else {
    return null;
  }
};

export const DescriptionWithIcon = ({
  children,
  iconImage,
  size,
  color,
  marginMobile,
  marginDesktop,
  ...otherProps
}) => {
  return (
    <FlexDiv>
      <IconImageDiv>{iconImage}</IconImageDiv>

      <DescriptionDiv>
        <Text
          type="p"
          size={size}
          color={color}
          marginMobile={marginMobile}
          marginDesktop={marginDesktop}
          {...otherProps}
        >
          {children}
        </Text>
      </DescriptionDiv>
    </FlexDiv>
  );
};

const FlexDiv = styled.div`
  width: 100%;
  display: flex;
`;

const IconImageDiv = styled.div`
  flex: 1;
  padding: ${props =>
      props.paddingTop === 'big'
        ? '15px'
        : props.paddingTop === 'normal'
        ? '13px'
        : props.paddingTop === 'small'
        ? '11px'
        : props.paddingTop}
    0 0;
`;

const DescriptionDiv = styled.div`
  width: 100%;
  padding-left: 1em;
`;

DescriptionWithIcon.defaultProps = {
  fontSize: 'big',
  color: '#354F5B',
  marginTop: '1em',
  marginBottom: '1em',
};
